var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { getLogger } from 'loglevel';
import { contains } from 'ramda';
import { isMobile } from '../utils/_.utils';
export var DEFAULT_LOG_LEVEL_VARIABLE = 'LOG_LEVEL';
export var LoggerLevel;
(function (LoggerLevel) {
    LoggerLevel["ERROR"] = "error";
    LoggerLevel["WARN"] = "warn";
    LoggerLevel["INFO"] = "info";
    LoggerLevel["DEBUG"] = "debug";
    LoggerLevel["TRACE"] = "trace";
})(LoggerLevel || (LoggerLevel = {}));
export var consoleAdapter = function (event) {
    var level = event.level, data = event.data;
    (console[level] || console.log).apply(void 0, __spreadArrays(['log:'], data));
};
var allowedLoggerLevels = Object.values(LoggerLevel);
var Logger = /** @class */ (function () {
    function Logger(config) {
        var _this = this;
        this.logMethodFactory = function (level) {
            return function () {
                var data = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    data[_i] = arguments[_i];
                }
                return _this.adapter({ level: level, data: data });
            };
        };
        this.refreshLoggerLevel = function () {
            if (_this.lastLevel !== _this.level) {
                _this.lastLevel = _this.level;
                _this.logger.setLevel(_this.level, false);
            }
        };
        this.onLog = function (level) { return function () {
            var _a;
            var agrs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                agrs[_i] = arguments[_i];
            }
            _this.refreshLoggerLevel();
            return (_a = _this.logger)[level].apply(_a, agrs);
        }; };
        this.log = this.onLog(LoggerLevel.DEBUG);
        this.info = this.onLog(LoggerLevel.INFO);
        this.warn = this.onLog(LoggerLevel.WARN);
        this.debug = this.onLog(LoggerLevel.DEBUG);
        this.error = this.onLog(LoggerLevel.ERROR);
        this.trace = this.onLog(LoggerLevel.TRACE);
        var name = config.name, adapter = config.adapter, variable = config.variable, defaultLevel = config.defaultLevel;
        this.adapter = adapter || consoleAdapter;
        this.variable = variable || DEFAULT_LOG_LEVEL_VARIABLE;
        this.defaultLevel = defaultLevel || LoggerLevel.ERROR;
        this.logger = getLogger(name);
        this.logger.methodFactory = this.logMethodFactory;
        this.refreshLoggerLevel();
    }
    Object.defineProperty(Logger.prototype, "processLogLevel", {
        get: function () {
            var level = process && process.env && process.env[this.variable];
            return this.str2Level(level);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "browserLogLevel", {
        get: function () {
            var level = isMobile() ? null : localStorage.getItem(this.variable);
            return this.str2Level(level);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "level", {
        get: function () {
            return this.browserLogLevel || this.manualLevel || this.processLogLevel || this.defaultLevel;
        },
        set: function (level) {
            this.manualLevel = this.str2Level(level);
            this.refreshLoggerLevel();
        },
        enumerable: true,
        configurable: true
    });
    Logger.prototype.setAdapter = function (adapter) {
        this.adapter = adapter;
    };
    Logger.prototype.str2Level = function (str) {
        var level = str && str.toLowerCase();
        return !!level && contains(level, allowedLoggerLevels) ? level : null;
    };
    return Logger;
}());
export { Logger };
//# sourceMappingURL=logger.js.map